import localForage from 'localforage';
import {extendPrototype} from 'localforage-observable';
import ZenObservable from 'zen-observable';

import {isDesktopApp} from '../utils';

export const draftsLocalForage = extendPrototype(localForage).createInstance({
    name: 'TiMe',
    storeName: 'drafts',
    version: 1,
});

declare global {
    interface Window {
        Observable: typeof ZenObservable;
    }
}

if (typeof window !== 'undefined') {
    // We need to polyfill Observable
    window.Observable = ZenObservable;
}

export function createDraftsObservable() {
    const isApp = isDesktopApp();

    return draftsLocalForage.newObservable({
        crossTabNotification: !isApp,
        changeDetection: true,
        crossTabChangeDetection: !isApp,
    });
}
